import { render, staticRenderFns } from "./EditJournal.vue?vue&type=template&id=3f0c76d0&scoped=true"
import script from "./EditJournal.vue?vue&type=script&lang=js"
export * from "./EditJournal.vue?vue&type=script&lang=js"
import style0 from "./EditJournal.vue?vue&type=style&index=0&id=3f0c76d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0c76d0",
  null
  
)

export default component.exports